import { FIELD_KEYS } from "./study-table-columns/columns.consts";

export const PATIENT_FIELDS = [FIELD_KEYS.PAT_NAME, FIELD_KEYS.PAT_BIRTHDATE];
